// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Сontacts_contasts__MWLwM .Сontacts_info__okE9Z {
  margin-top: 100px;
}
@media (max-width: 640px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z {
    margin-top: 80px;
  }
}
@media (max-width: 480px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z {
    margin-top: 50px;
  }
}
.Сontacts_contasts__MWLwM .Сontacts_info__okE9Z p {
  max-width: 1100px;
  color: #000;
  font-size: 1.2rem;
  font-family: "Open Sans";
  padding: 0;
}
.Сontacts_contasts__MWLwM .Сontacts_info__okE9Z p strong {
  color: var(--red);
  font-size: 1.4rem;
  font-family: "Rubik Glitch", cursive;
  font-weight: 400;
}
.Сontacts_contasts__MWLwM .Сontacts_info__okE9Z p.Сontacts_max_text__--Hbc {
  margin-top: 3rem;
  max-width: 600px;
}
@media (max-width: 1060px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z p.Сontacts_max_text__--Hbc {
    max-width: 500px;
  }
}
@media (max-width: 780px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z p.Сontacts_max_text__--Hbc {
    max-width: 400px;
  }
}
.Сontacts_contasts__MWLwM .Сontacts_info__okE9Z h2 {
  text-align: end;
  color: var(--chervonyy, #CC2E2E);
  font-size: 12rem;
  margin: -40px 30px 0 0;
  font-family: "Rubik Glitch", cursive;
  font-weight: 400;
}
@media (max-width: 1320px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z h2 {
    font-size: 9rem;
  }
}
@media (max-width: 780px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z h2 {
    font-size: 6rem;
  }
}
@media (max-width: 640px) {
  .Сontacts_contasts__MWLwM .Сontacts_info__okE9Z h2 {
    display: none;
  }
}
.Сontacts_contasts__MWLwM footer {
  box-sizing: border-box;
  width: calc(100% + 100px);
  padding: 2rem 3.3rem;
  background-color: var(--red);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
@media (max-width: 670px) {
  .Сontacts_contasts__MWLwM footer {
    width: calc(100% + 100px);
    margin-left: -50px;
  }
}
@media (max-width: 640px) {
  .Сontacts_contasts__MWLwM footer {
    margin-top: 40px;
  }
}
.Сontacts_contasts__MWLwM footer .Сontacts_info_footer__AUueI {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.Сontacts_contasts__MWLwM footer .Сontacts_info_footer__AUueI h3 {
  font-family: "Beer money";
  font-weight: 400;
  font-size: 2rem;
  margin: 0 0 0.8rem 0;
  color: #fff;
}
.Сontacts_contasts__MWLwM footer .Сontacts_info_footer__AUueI p {
  margin: 0;
  color: #fff;
  font-size: 1rem;
  font-family: "Open Sans";
}
.Сontacts_contasts__MWLwM footer .Сontacts_btn__HUUyh {
  margin: 20px -2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/%D0%A1ontacts/%D0%A1ontacts.module.scss","webpack://./src/pages/Сontacts/Сontacts.module.scss"],"names":[],"mappings":"AAGG;EACG,iBAAA;ACFN;ADIM;EAHH;IAIM,gBAAA;ECDP;AACF;ADGM;EAPH;IAQM,gBAAA;ECAP;AACF;ADEM;EACG,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;ACAT;ADES;EACG,iBAAA;EACA,iBAAA;EACA,oCAAA;EACA,gBAAA;ACAZ;ADIM;EACG,gBAAA;EACA,gBAAA;ACFT;ADIS;EAJH;IAKM,gBAAA;ECDV;AACF;ADGS;EARH;IASM,gBAAA;ECAV;AACF;ADGM;EACG,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;ACDT;ADGS;EARH;IASM,eAAA;ECAV;AACF;ADES;EAZH;IAaM,eAAA;ECCV;AACF;ADCS;EAhBH;IAiBM,aAAA;ECEV;AACF;ADGG;EACG,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;ACDN;ADGM;EAXH;IAYM,yBAAA;IACA,kBAAA;ECAP;AACF;ADEM;EAhBH;IAiBM,gBAAA;ECCP;AACF;ADCM;EACG,aAAA;EACA,sBAAA;EACA,WAAA;ACCT;ADCS;EACG,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;ACCZ;ADCS;EACG,SAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;ACCZ;ADGM;EACG,iBAAA;ACDT","sourcesContent":["\r\n\r\n.contasts{\r\n   .info{\r\n      margin-top: 100px;\r\n\r\n      @media (max-width: 640px) {\r\n         margin-top: 80px;\r\n      }\r\n\r\n      @media (max-width: 480px) {\r\n         margin-top: 50px;\r\n      }\r\n\r\n      p{\r\n         max-width: 1100px;\r\n         color: #000;\r\n         font-size: 1.2rem;\r\n         font-family: 'Open Sans';\r\n         padding: 0;\r\n         \r\n         strong {\r\n            color: var(--red);\r\n            font-size: 1.4rem;\r\n            font-family: 'Rubik Glitch', cursive;\r\n            font-weight: 400;\r\n         }\r\n      }\r\n   \r\n      p.max_text{\r\n         margin-top: 3rem;\r\n         max-width: 600px;\r\n\r\n         @media (max-width: 1060px) {\r\n            max-width: 500px;\r\n         }\r\n\r\n         @media (max-width: 780px) {\r\n            max-width: 400px;\r\n         }\r\n      }\r\n   \r\n      h2{\r\n         text-align: end;\r\n         color: var(--chervonyy, #CC2E2E);\r\n         font-size: 12rem;\r\n         margin: -40px 30px 0 0;\r\n         font-family: 'Rubik Glitch', cursive;\r\n         font-weight: 400;\r\n\r\n         @media (max-width: 1320px) {\r\n            font-size: 9rem;\r\n         }\r\n   \r\n         @media (max-width: 780px) {\r\n            font-size: 6rem;\r\n         }\r\n\r\n         @media (max-width: 640px) {\r\n            display: none;\r\n         }\r\n         \r\n      }\r\n   }\r\n\r\n   footer{\r\n      box-sizing: border-box;\r\n      width: calc(100% + 100px);\r\n      padding: 2rem 3.3rem;\r\n      background-color: var(--red);\r\n      color: #fff;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      flex-wrap: wrap;\r\n\r\n      @media (max-width: 670px) {\r\n         width: calc(100% + 100px);\r\n         margin-left: -50px;\r\n      }\r\n\r\n      @media (max-width: 640px) {\r\n         margin-top: 40px;\r\n      }\r\n\r\n      .info_footer{\r\n         display: flex;\r\n         flex-direction: column;\r\n         gap: 0.4rem;\r\n\r\n         h3{\r\n            font-family: \"Beer money\";\r\n            font-weight: 400;\r\n            font-size: 2rem;\r\n            margin: 0 0 0.8rem 0;\r\n            color: #fff;\r\n         }\r\n         p{\r\n            margin: 0;\r\n            color: #fff;\r\n            font-size: 1rem;\r\n            font-family: 'Open Sans';\r\n         }\r\n      }\r\n\r\n      .btn{\r\n         margin: 20px -2px;\r\n      }\r\n   }\r\n}",".contasts .info {\n  margin-top: 100px;\n}\n@media (max-width: 640px) {\n  .contasts .info {\n    margin-top: 80px;\n  }\n}\n@media (max-width: 480px) {\n  .contasts .info {\n    margin-top: 50px;\n  }\n}\n.contasts .info p {\n  max-width: 1100px;\n  color: #000;\n  font-size: 1.2rem;\n  font-family: \"Open Sans\";\n  padding: 0;\n}\n.contasts .info p strong {\n  color: var(--red);\n  font-size: 1.4rem;\n  font-family: \"Rubik Glitch\", cursive;\n  font-weight: 400;\n}\n.contasts .info p.max_text {\n  margin-top: 3rem;\n  max-width: 600px;\n}\n@media (max-width: 1060px) {\n  .contasts .info p.max_text {\n    max-width: 500px;\n  }\n}\n@media (max-width: 780px) {\n  .contasts .info p.max_text {\n    max-width: 400px;\n  }\n}\n.contasts .info h2 {\n  text-align: end;\n  color: var(--chervonyy, #CC2E2E);\n  font-size: 12rem;\n  margin: -40px 30px 0 0;\n  font-family: \"Rubik Glitch\", cursive;\n  font-weight: 400;\n}\n@media (max-width: 1320px) {\n  .contasts .info h2 {\n    font-size: 9rem;\n  }\n}\n@media (max-width: 780px) {\n  .contasts .info h2 {\n    font-size: 6rem;\n  }\n}\n@media (max-width: 640px) {\n  .contasts .info h2 {\n    display: none;\n  }\n}\n.contasts footer {\n  box-sizing: border-box;\n  width: calc(100% + 100px);\n  padding: 2rem 3.3rem;\n  background-color: var(--red);\n  color: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n@media (max-width: 670px) {\n  .contasts footer {\n    width: calc(100% + 100px);\n    margin-left: -50px;\n  }\n}\n@media (max-width: 640px) {\n  .contasts footer {\n    margin-top: 40px;\n  }\n}\n.contasts footer .info_footer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.contasts footer .info_footer h3 {\n  font-family: \"Beer money\";\n  font-weight: 400;\n  font-size: 2rem;\n  margin: 0 0 0.8rem 0;\n  color: #fff;\n}\n.contasts footer .info_footer p {\n  margin: 0;\n  color: #fff;\n  font-size: 1rem;\n  font-family: \"Open Sans\";\n}\n.contasts footer .btn {\n  margin: 20px -2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contasts": `Сontacts_contasts__MWLwM`,
	"info": `Сontacts_info__okE9Z`,
	"max_text": `Сontacts_max_text__--Hbc`,
	"info_footer": `Сontacts_info_footer__AUueI`,
	"btn": `Сontacts_btn__HUUyh`
};
export default ___CSS_LOADER_EXPORT___;
